import React, { useState } from 'react'
import { isNil } from 'lodash-es'
import { DialogRow, NumericInputField } from 'view/components/inputs'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { Decimal } from 'utils'
import { Locale, Translation } from 'locale'
import * as constants from 'view/styles/constants'
import { TableCell } from './servicingDialogStyles'

export interface ServicingRerateDialogComponentProps {
  handleRerate: (adjusment: number, isBips: boolean) => void
}

export const BulkRerateInputs: React.FunctionComponent<ServicingRerateDialogComponentProps> = props => {
  const { handleRerate } = props
  const [rerateBips, setRerateBips] = useState<number | null | undefined>(null)
  const [reratePercentage, setReratePercentage] = useState<number | null | undefined>(null)

  const handleClickRerate = () => {
    if (isNil(reratePercentage) && !isNil(rerateBips)) {
      const bipsAdjustment = Decimal.multiply(rerateBips, 0.0001)
      handleRerate(bipsAdjustment, true)
      setRerateBips(null)
    } else if (!isNil(reratePercentage) && isNil(rerateBips)) {
      const percentageAdjustment = Decimal.multiply(reratePercentage, 0.01)
      handleRerate(percentageAdjustment, false)
      setReratePercentage(null)
    }
  }

  return (
    <>
      <DialogRow verticalLayout={constants.VerticalLayout.Center}>
        <TableCell>{Locale.translate(Translation.SC_ADJUST_ALL_RATES)}</TableCell>
        <TableCell onFocus={() => setReratePercentage(null)}>
          <NumericInputField
            label=""
            fieldName="rerateBips"
            value={rerateBips}
            onUpdate={(value: number | null | undefined) => setRerateBips(value)}
            dataTestId={'ServicingRerateDialog-AdjustAllRatesByNumericInputField'}
          />
        </TableCell>
        <TableCell>{Locale.translate(Translation.SC_BPS)}</TableCell>
        <TableCell>OR</TableCell>
      </DialogRow>
      <DialogRow verticalLayout={constants.VerticalLayout.Center}>
        <TableCell>{Locale.translate(Translation.SC_UPDATE_ALL_RATES)}</TableCell>
        <TableCell onFocus={() => setRerateBips(null)}>
          <NumericInputField
            label=""
            fieldName="reratePercentage"
            value={reratePercentage}
            onUpdate={(value: number | null | undefined) => setReratePercentage(value)}
            dataTestId={'ServicingRerateDialog-AdjustAllRatesByPercentageInputField'}
          />
        </TableCell>
        <TableCell>%</TableCell>
        <TableCell style={{ visibility: 'hidden' }}>OR&nbsp;</TableCell>
        <TableCell>
          <TextButton
            type={TextButtonType.Primary}
            disabled={isNil(rerateBips) && isNil(reratePercentage)}
            onClick={handleClickRerate}
            dataTestId={'ServicingRerateDialog-CalculateButton'}>
            {Locale.translate(Translation.TC_BUTTON_APPLY)}
          </TextButton>
        </TableCell>
        <TableCell>{Locale.translate(Translation.SC_OR_ENTER_MANUALLY)}</TableCell>
      </DialogRow>
    </>
  )
}
